import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* checkPhoneNumber(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.CHECK_PHONE_NUMBER_REQUEST
    });

    const res = yield call(Http.post, `contacts/formatPhoneNumber`, {...action.payload});

    yield put({
      type: Constants.CHECK_PHONE_NUMBER_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.phoneNumber);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.CHECK_PHONE_NUMBER_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCheckPhoneNumber() {
  yield takeEvery(Constants.CHECK_PHONE_NUMBER_START, checkPhoneNumber);
}
